import React from "react";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function DescargarFormulario({ clientes, clientesFiltrados }) {
  const exportarExcel = async () => {
    // Solo exportamos la página visible
    const dataToExport =
      clientesFiltrados && clientesFiltrados.length > 0
        ? clientesFiltrados
        : clientes;

    if (!dataToExport || dataToExport.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Clientes");

    // Filas vacías para estructura
    sheet.addRow([]);
    sheet.addRow([]);
    sheet.addRow([]); // Aquí irá el título
    sheet.addRow([]);
    sheet.addRow([]);

    // Título
    sheet.mergeCells("A3:H3");
    const titleCell = sheet.getCell("B3");
    titleCell.value = "LISTADO DE CLIENTES";
    titleCell.font = { size: 30, bold: true };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    sheet.getRow(3).height = 40;

    // Encabezados
    const headers = [
      "CLIENTE",
      "TIPO DOC.",
      "DOCUMENTO",
      "TELEFONO",
      "ESTADO",
      "LINEA DE CREDITO",
      "EMAIL",
      "DIRECCION",
      "COD. CLIENTE",
      "ALERTA ACTIVADA",
    ];

    const headerRow = sheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF008000" },
      };
      cell.alignment = { horizontal: "center" };
    });

    // Datos
    dataToExport.forEach((cliente) => {
      const row = sheet.addRow([
        cliente.nombre || "",
        cliente.codigoTipodocumento || "",
        cliente.documento || "",
        cliente.dataTelefono1 || "",
        cliente.estadoNombre || "",
        cliente.valorCreditomaximo || "",
        cliente.dataEmail || "",
        cliente.dataDireccion || "",
        cliente.codigo || "",
        cliente.clieCdAlertaE || "",
      ]);

      row.eachCell((cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    });

    // Ajustar ancho de columnas
    sheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) maxLength = columnLength;
      });
      column.width = maxLength + 5;
    });

    // Guardar archivo
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Clientes.xlsx");
  };

  const exportarPDF = () => {
    const dataToExport =
      clientesFiltrados && clientesFiltrados.length > 0
        ? clientesFiltrados
        : clientes;

    if (!dataToExport || dataToExport.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const doc = new jsPDF();
    doc.text("Reporte de Clientes", 14, 20);

    const data = dataToExport.map((cliente) => [
      cliente.id,
      cliente.nombre,
      cliente.documento,
      cliente.dataTelefono1,
      cliente.dataEmail,
      cliente.dataDireccion,
    ]);

    const headers = [
      ["ID", "Nombre", "Documento", "Teléfono", "Email", "Dirección"],
    ];

    autoTable(doc, {
      head: headers,
      body: data,
      startY: 30,
      styles: { fontSize: 8, textColor: [0, 0, 0] },
      headStyles: {
        fillColor: [0, 128, 0],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: { fillColor: [245, 245, 245] },
      alternateRowStyles: { fillColor: [220, 240, 220] },
    });

    doc.save("Clientes.pdf");
  };

  const descargarWord = () => {
    const link = document.createElement("a");
    link.href = "/solicitud.docx";
    link.download = "solicitud.docx";
    link.click();
  };

  return (
    <div className="inline-block w-full">
      <span onClick={descargarWord} className="text-link">
        Descargar Formulario
      </span>

      <div className="absolute right-10 top-36 flex flex-row space-x-2">
        <button
          onClick={exportarExcel}
          className="btn-excel"
          title="Exportar a Excel"
        >
          <FaFileExcel size={16} />
        </button>
        <button
          onClick={exportarPDF}
          className="btn-pdf"
          title="Exportar a PDF"
        >
          <FaFilePdf size={16} />
        </button>
      </div>
    </div>
  );
}

export default DescargarFormulario;
